<div class="register-form no-text-select">
    <form [formGroup]="registerForm" (ngSubmit)="onRegister()" class="no-text-select">
        <section *ngIf=!started>
            <div class="title row">
                <p class="welcome">Bienvenido</p>
                <p>Tu privacidad es importante, por eso queremos saber primero tus preferencias
                </p>
            </div>

            <div class="row ">
                <app-check-box formControlName="insuranceAdvertising">
                    <div class="inner-check">
                        <p>Publicidad de Seguros: </p>
                        <p>No estoy de acuerdo que, previa evaluación de mis cualidades, se me ofrezca publicidad de seguros.
                        </p>
                    </div>
                </app-check-box>
            </div>

            <div class="row">
                <app-check-box formControlName="legalServicesAdvertising">
                    <div class="inner-check">
                        <p>Publicidad de Servicios Legales: </p>
                        <p>Acepto que onLygal Seguros ceda mis datos a la empresa del Grupo, Onlygal Servicios Legales, S.L., para que esta me remita información publicitaria referida a servicios legales.</p>
                    </div>
                </app-check-box>
            </div>
        </section>

        <section *ngIf=started class="register-section">
            <div class="header-block">
                <div class="title-head">
                    <p class="welcome">¡Hola!</p>
                    <span class="step-badge">Paso 1 de 3</span>
                </div>
                <p class="subtitle">Para registrarte en el <strong>"Área de clientes"</strong> necesitamos que rellenes los siguientes datos</p>
            </div>

            <div class="fields-block">

                <!-- Tipo + Número de documento -->
                <div class="cont-select">
                    <div class="inner-select">
                        <select formControlName="documentType" required class="field-input select-field">
                            <option value="NIF">NIF</option>
                            <option value="NIE">NIE</option>
                            <option value="CIF">CIF</option>
                        </select>
                    </div>
                    <div class="inner-input">
                        <label class="field-label">Número de documento</label>
                        <input type="text" class="field-input" formControlName="documentNumber"
                            placeholder="Introduce tu número de documento"
                            minlength="9" maxlength="9" autocomplete="off">
                        <span class="field-description">Completo con cifras y letras</span>
                    </div>
                </div>

                <!-- Correo electrónico -->
                <div class="field-group">
                    <label class="field-label">Correo electrónico</label>
                    <input type="email" class="field-input" formControlName="email"
                        placeholder="Introduce tu correo electrónico"
                        maxlength="255" autocomplete="off">
                    <span class="field-description">Lo necesitamos para confirmar tu registro.</span>
                </div>

                <!-- Prefijo + Teléfono móvil -->
                <div class="cont-select">
                    <div class="inner-select">
                        <angular2-multiselect [data]="prefixData" [settings]="prefixSettings"
                            formControlName="mobilePhonePrefix">
                            <c-badge>
                                <ng-template let-item="item">
                                    <label class="phoneBadge">
                                        <span *ngIf="undefined !== item.id" class="flags flag{{item.id}}"></span>
                                        <span *ngIf="undefined !== item.id">+{{item.id}}</span>
                                        <span *ngIf="undefined !== item.id">{{item.itemName}}</span>
                                    </label>
                                </ng-template>
                            </c-badge>
                            <c-item>
                                <ng-template let-item="item">
                                    <label class="phoneItem" style="min-width: 200px; font-family: 'AVENIR'; display: flex; align-items: center; gap: 8px;">
                                        <span class="flags flag{{item.id}}"></span>
                                        <span>+{{item.id}}</span>
                                        <span>{{item.itemName}}</span>
                                    </label>
                                </ng-template>
                            </c-item>
                        </angular2-multiselect>
                    </div>
                    <div class="inner-input">
                        <label class="field-label">Teléfono móvil</label>
                        <input type="tel" class="field-input" formControlName="mobilePhone"
                            placeholder="Introduce tu número de teléfono"
                            maxlength="18" autocomplete="off">
                        <span class="field-description">Lo necesitamos para confirmar tu registro.</span>
                    </div>
                </div>

                <!-- Número de póliza -->
                <div class="field-group" *ngIf="!isReinsured && !isInnominado">
                    <label class="field-label">Número de póliza / Contrato</label>
                    <input type="text" class="field-input" formControlName="policy"
                        placeholder="Introduce tu número de póliza o contrato"
                        maxlength="8" autocomplete="off"
                        title="Número de 8 dígitos que encontrarás en el apartado Condiciones particulares de tu contrato.">
                    <span class="field-description">Para comprobar que eres cliente nuestro.</span>
                </div>

                <!-- Número de siniestro -->
                <div class="field-group" *ngIf="isReinsured || isInnominado">
                    <label class="field-label">Número de Siniestro/Parte</label>
                    <input type="text" class="field-input" formControlName="event"
                        placeholder="Introduce tu número de siniestro o parte"
                        maxlength="8" autocomplete="off"
                        title="Número de 8 dígitos que encontrarás en el correo electrónico que te hemos enviado.">
                    <span class="field-description">Para comprobar que eres cliente nuestro.</span>
                </div>

                <!-- reCAPTCHA -->
                <div class="reca">
                    <app-google-recaptcha (onRecaptcha)="onRecaptcha($event)"></app-google-recaptcha>
                </div>

                <app-error-messages *ngIf="messages && messages.length && null === recoveryHtml" [(messages)]=messages></app-error-messages>

                <div class="recovery" *ngIf="null !== recoveryHtml" [innerHtml]="recoveryHtml | safeHtml"></div>
            </div>
        </section>

        <div class="button-block">
            <app-spinner-button [label]="getButtonLabel()" [enabled]="submitEnabled()" [running]="running">
            </app-spinner-button>
            <app-contact-line [isReinsuredParam]="isReinsured"></app-contact-line>
        </div>
    </form>
</div>
